import createDataContext from './createDataContext'

interface StateType {
    allNewParts: any,
    documentItems: any
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    allNewParts: {},
    documentItems: {}
}

const reducer = (state, action: ActionType) => {
    
    switch(action.type)
    {
        case 'getAllNewPartsData': return { ...state, allNewParts: action.payload }

        default: return state
    }

}

const getAllDocumentsForVendorSortingEntity = dispatch => {

    return async (variables, getAllDocumentsForVendorSortingEntity, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            
            const response = await getAllDocumentsForVendorSortingEntity({ variables })

            !!callback ? callback?.(response.data?.getAllDocumentsForVendorSortingEntity) : null

        } catch(e)
        {
            console.log('GET ALL DOCUMENTS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const addPartsToInvoice = dispatch => {

    return async (variables, addPartsToInvoice, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await addPartsToInvoice({ variables })

            !!callback ? callback?.(response.data?.addInventoryReplenishmentProductToInvoiceMutation) : null

        } catch(e)
        {
            console.log('ADD PARTS TO INVOICE ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const createDocument = dispatch => {

    return async (variables, createDocument, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await createDocument({ variables })

            !!callback ? callback?.(response.data?.createDocumentMutation) : null

        } catch(e)
        {
            console.log('CREATE DOCUMENT ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const submitInvoice = dispatch => {

    return async (variables, submitInvoice, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await submitInvoice({ variables })

            !!callback ? callback?.(response.data?.updateDocumentV2Mutation) : null

        } catch(e)
        {
            console.log('SUBMIT INVOICE ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllDocumentItemsByDocNoAndType = dispatch => {

    return async (variables, getAllDocumentItemsByDocNoAndType, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            
            const response = await getAllDocumentItemsByDocNoAndType({ variables })

            dispatch({ type: 'getAllDocumentItemsByDocNoAndType', payload: response.data?.getAllDocumentItemsByDocumentNumberAndType })

            !!callback ? callback?.(response.data?.getAllDocumentItemsByDocumentNumberAndType) : null

        } catch(e)
        {
            console.log('GET ALL DOCUMENT ITEMS BY DOC NO AND TYPE ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllVendors = dispatch => {

    return async (variables, getAllVendors, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllVendors({ variables })

            !!callback ? callback?.(response.data?.getAllVendors) : null

        } catch(e)
        {
            console.log('GET ALL VENDORS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getInvoiceData = dispatch => {

    return async (variables, getInvoiceData, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getInvoiceData({ variables })

            !!callback ? callback?.(response.data?.getDocument) : null

        } catch(e)
        {
            console.log('GET INVOICE DATA ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAllNewPartsData = dispatch => {

    return async (variables, getAllNewPartsData, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllNewPartsData({ variables })

            dispatch({ type: 'getAllNewPartsData', payload: response.data?.getAllInventoryReplenishmentRequestItemsGroupByProduct })
            
            !!callback ? callback?.(response.data?.getAllInventoryReplenishmentRequestItemsGroupByProduct) : null

        } catch(e)
        {
            console.log('GET ALL NEW PARTS DATA ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const requestPayment = dispatch => {

    return async (variables, requestPaymentMutation, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await requestPaymentMutation({ variables })

            !!callback ? callback?.(response.data?.requestForPaymentMutation) : null

        } catch(e)
        {
            console.log('REQUEST PAYMENT ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

export interface InvoiceInterface {
    state: StateType,
    getAllNewPartsData: (variables, getAllNewPartsData, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getInvoiceData: (variables, getInvoiceData, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllVendors: (variables, getAllVendors, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllDocumentItemsByDocNoAndType: (variables, getAllDocumentItemsByDocNoAndType, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    submitInvoice: (variables, submitInvoice, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    createDocument: (variables, createDocument, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    addPartsToInvoice: (variables, addPartsToInvoice, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAllDocumentsForVendorSortingEntity: (variables, getAllDocuments, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    requestPayment: (variables, requestPaymentMutation, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
}

export const { Context: InvoiceContext, Provider: InvoiceProvider } = createDataContext(reducer,
    { getAllNewPartsData, getInvoiceData, getAllVendors, getAllDocumentItemsByDocNoAndType, submitInvoice, createDocument, addPartsToInvoice, getAllDocumentsForVendorSortingEntity, requestPayment },
    initialState)
